import { Code, Group } from '@mantine/core';
import {
    IconBrandWhatsapp,
    IconCalendarStats,
    IconCoin,
    IconCreditCard,
    IconGauge,
    IconHeart,
    IconRocket,
    IconScissors,
    IconSettings,
    IconStar,
    IconUsers,
    IconWorld
} from '@tabler/icons-react';
import classes from './BarraLateral.module.css';

const BarraLateral = ({
    user,
    activeSection,
    setActiveSection,
    isSidebarOpen,
    setIsSidebarOpen,
    onBack,
    unitLogo,
    unitName
}) => {
    const allMenuItems = [
        { id: 'dashboard', label: 'Dashboard', icon: IconGauge },
        { id: 'agenda', label: 'Agenda', icon: IconCalendarStats },
        { id: 'services', label: 'Serviços', icon: IconScissors },
        { id: 'team', label: 'Equipe', icon: IconUsers },
        { id: 'financeiro', label: 'Financeiro', icon: IconCoin },
        { id: 'settings', label: 'Ajustes', icon: IconSettings },
        { id: 'reviews', label: 'Avaliação', icon: IconStar },
        { id: 'marketing', label: 'Marketing', icon: IconRocket },
        { id: 'fidelizacao', label: 'Fidelização', icon: IconHeart },
        { id: 'assinatura', label: 'Assinatura', icon: IconCreditCard },
    ];

    const isEmployee = user?.role === 'barber';
    const menuItems = isEmployee
        ? allMenuItems.filter(item => ['dashboard', 'agenda'].includes(item.id))
        : allMenuItems;

    const links = menuItems.map((item) => {
        const Icon = item.icon;
        return (
            <a
                className={classes.link}
                data-active={item.id === activeSection || undefined}
                key={item.id}
                onClick={(event) => {
                    event.preventDefault();
                    setActiveSection(item.id);
                    setIsSidebarOpen(false);
                }}
            >
                {Icon && <Icon className={classes.linkIcon} stroke={2} />}
                <span>{item.label}</span>
            </a>
        );
    });

    return (
        <nav className={`${classes.navbar} ${isSidebarOpen ? classes.show : ''}`}>
            <div className={classes.navbarMain}>
                <Group className={classes.header} justify="space-between">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {unitLogo ? (
                            <img src={unitLogo} alt={unitName} style={{ width: 32, height: 32, borderRadius: 6 }} />
                        ) : (
                            <div style={{ width: 32, height: 32, borderRadius: 6, background: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '900', color: '#fff', fontSize: '14px', border: '1px solid #333' }}>
                                {unitName?.charAt(0) || 'B'}
                            </div>
                        )}
                        <span style={{ color: '#ffffff', fontWeight: '800', fontSize: '1rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '160px' }}>
                            {unitName || 'Barbearia'}
                        </span>
                    </div>
                    <Code fw={800} style={{ background: 'rgba(255, 255, 255, 0.1)', color: '#ffffff', padding: '2px 8px' }}>v2.0</Code>
                </Group>
                {links}

                <div style={{ marginTop: '10px' }}>
                    <a
                        href="#"
                        className={classes.link}
                        onClick={(event) => {
                            event.preventDefault();
                            onBack();
                        }}
                    >
                        <IconWorld className={classes.linkIcon} stroke={2} />
                        <span>Voltar ao Site</span>
                    </a>
                </div>

                <a
                    href="#"
                    className={classes.link}
                    onClick={(event) => {
                        event.preventDefault();
                        window.open(`https://wa.me/5534997354131?text=Olá! Preciso de ajuda com o Painel de Controle da minha unidade ${unitName}.`, '_blank');
                    }}
                >
                    <IconBrandWhatsapp className={classes.linkIcon} stroke={2} />
                    <span>Suporte Técnico</span>
                </a>
            </div>
        </nav>
    );
};

export default BarraLateral;
